
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/schema-setup",
      function () {
        return require("private-next-pages/customer-studio/schema-setup.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/schema-setup"])
      });
    }
  